import WizardView from './wizard-view';
import { WIZARD_STEPS } from './wizard-config';
import WizardState from './wizard-state'

export default class WizardManager {
    constructor() {
        this.state = new WizardState();
        this.view = new WizardView(this);
        this.initialized = false;
    }

    initialize() {
        if (this.initialized) return;
        
        // Only show wizard for new users (no email in localStorage)
        const userEmail = localStorage.getItem('userEmail');
        console.log('WizardManager initializing, userEmail:', userEmail);
        
        this.view.createHelpIcon();
        
        // Check if form overlay is visible for new users
        if (!userEmail) {
            const formOverlay = document.getElementById('form-overlay');
            console.log('Form overlay status:', formOverlay?.classList.contains('hidden'));
            if (!formOverlay || formOverlay.classList.contains('hidden')) {
                return;
            }
            // Automatically start wizard for new users
            console.log('Starting wizard for new user');
            this.startWizard();
        }

        this.attachEventListeners();
        this.initialized = true;
    }

    attachEventListeners() {
        const helpIcon = document.getElementById('wizard-help-icon');
        if (helpIcon) {
            helpIcon.addEventListener('click', () => {
                // Clear any existing wizard state
                if (this.view.content) {
                    this.view.content.remove();
                    this.view.content = null;
                }
                if (this.view.overlay) {
                    this.view.overlay.remove();
                    this.view.overlay = null;
                }
                
                // Create fresh wizard elements and start
                this.view.createWizardOverlay();
                this.startWizard();
            });
        }

        window.addEventListener('resize', () => {
            if (this.state.isActive) {
                this.view.updateHighlightPosition();
            }
        });
    }

    startWizard() {
        console.log('startWizard called');
        this.state.reset();
        this.view.showWizard();
        this.goToStep(1);
    }


    goToStep(stepNumber) {
        console.log('Going to step:', stepNumber);
        if (stepNumber > Object.keys(WIZARD_STEPS).length) {
            this.completeWizard();
            return;
        }

        this.state.currentStep = stepNumber;
        this.view.updateStep(WIZARD_STEPS[stepNumber]);
        this.view.highlightSection(WIZARD_STEPS[stepNumber].targetSection);
    }

    completeWizard() {
        this.state.complete();
        this.view.hideWizard();
    }

    skipWizard() {
        this.state.skip();
        this.view.hideWizard();
    }

    handleInteraction(targetSection) {
        if (this.state.isActive && !this.state.isPaused) {
            const currentStep = WIZARD_STEPS[this.state.currentStep];
            if (currentStep.targetSection === targetSection) {
                this.goToStep(this.state.currentStep + 1);
            }
        }
    }
}
